import { HTMLMotionProps, motion } from "motion/react";
import styled from "styled-components";

const PageBaseContainer = styled(motion.div)`
    min-height: 100%;
    overflow-x: hidden;
`;

export const PageBase = (props: HTMLMotionProps<"div">) => {
    return (
        //@ts-ignore
        <PageBaseContainer
            style={
                {
                    // position: "absolute",
                    // inset: 0,
                    // width: "100%",
                    // height: "100%",
                }
            }
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            {...props}
        />
    );
};
